import type { DeepPartial } from 'react-hook-form';

import type { StepListingsCompareFragment } from '@graphql/__generated__/graphql';
import { composePropertyType } from '@modules/_shared/utils/propertyTypes';

export const getAutoAlgoParams = (
  property: DeepPartial<StepListingsCompareFragment['property']> | undefined,
  countryCode: string,
  limit: number | null = 10,
) => {
  const propertyType = property?.property_type || {};

  return {
    variables: {
      lat: property?.lat ?? 0,
      lng: property?.lng ?? 0,
      living_surface: property?.living_surface ?? null,
      built_surface: property?.built_surface ?? null,
      usable_surface: property?.usable_surface ?? null,
      number_of_rooms: Math.round(
        property?.number_of_rooms ?? property?.number_of_bedrooms ?? 0,
      ),
      property_main_type: composePropertyType(
        propertyType?.main_type ?? null,
        propertyType?.name ?? null,
      ),
      sale_price: property?.latest_appraisal?.value,
      limit,
      ch: countryCode === 'CH',
      es: countryCode === 'ES',
      fr: countryCode === 'FR',
      it: countryCode === 'IT',
      pl: countryCode === 'PL',
      pt: countryCode === 'PT',
    },
    context: {
      clientName: 'scrapers',
    },
  };
};
